import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X, ZoomIn, ZoomOut } from "lucide-react";
import { media } from "@/lib/api";

export const Lightbox = ({ items, index, onClose, onIndex }) => {
  const [zoom, setZoom] = useState(1);
  const open = index !== null && index !== undefined && items?.[index];
  useEffect(() => {
    const k = (e) => {
      if (!open) return;
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [open, index, items, onClose, onIndex]);
  useEffect(() => { setZoom(1); }, [index]);
  const it = open ? items[index] : null;
  return (
    <AnimatePresence>
      {it && (
        <motion.div className="fixed inset-0 z-[90] bg-[#0B1D14]/95 backdrop-blur-md flex flex-col" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="lightbox">
          <div className="flex items-center justify-between p-4 md:p-6">
            <p className="font-mono-x text-xs tracking-[0.2em] text-[#C9A24B]">{index + 1} / {items.length}</p>
            <div className="flex gap-2">
              <button className="lb-btn" onClick={() => setZoom((z) => Math.min(3, z + 0.5))} data-testid="lightbox-zoom-in" aria-label="Zoom in"><ZoomIn size={18} /></button>
              <button className="lb-btn" onClick={() => setZoom((z) => Math.max(1, z - 0.5))} data-testid="lightbox-zoom-out" aria-label="Zoom out"><ZoomOut size={18} /></button>
              <button className="lb-btn" onClick={onClose} data-testid="lightbox-close" aria-label="Close"><X size={18} /></button>
            </div>
          </div>
          <div className="flex-1 flex items-center justify-center overflow-hidden px-4 relative">
            <button className="lb-btn absolute left-3 md:left-6 z-10" onClick={() => onIndex((index - 1 + items.length) % items.length)} data-testid="lightbox-prev" aria-label="Previous"><ChevronLeft /></button>
            <motion.img key={it.url} src={media(it.url)} alt={it.caption || "Historic photo"} initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: zoom }} transition={{ duration: 0.5 }}
              className="max-h-[75vh] max-w-full object-contain border border-[#C9A24B]/50 rounded" />
            <button className="lb-btn absolute right-3 md:right-6 z-10" onClick={() => onIndex((index + 1) % items.length)} data-testid="lightbox-next" aria-label="Next"><ChevronRight /></button>
          </div>
          <div className="p-5 md:p-8 text-center">
            <p className="font-accent italic text-lg text-[#F6EFE0]" data-testid="lightbox-caption">{it.story || it.caption || ""}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
